import { jwtDecode } from 'jwt-decode';
import { SP_REFRESH_TOKEN, SP_ACCESS_TOKEN } from './constants/State';
import { isLocalHost, isEmpty } from './utils/utils';
import { TOKEN } from './constants';

export const setCookie = (
  cookieName,
  cookieValue,
  msSeconds = 900000,
  domain,
  path = '/',
) => {
  const d = new Date();
  d.setTime(d.getTime() + msSeconds);
  const expires = `expires=${d.toUTCString()}`;
  const _domain = isLocalHost() || !domain ? '' : `;domain=${domain}`;
  document.cookie = `${cookieName}=${cookieValue};${expires}${_domain};path=${path}`;
};

export const getCookie = (cookieName) => {
  const match = document.cookie.match(new RegExp(`(^| )${cookieName}=([^;]+)`));
  return match != null ? match[2].replace(/['"]+/g, '') : '';
};

export const deleteCookie = (cookieName, domain, path = '/') => {
  if (getCookie(cookieName)) {
    const _domain = isLocalHost() || !domain ? '' : `;domain=${domain}`;
    document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT${_domain};path=${path}`;
  }
};

export const deleteAllCookies = (domain, path = '/') => {
  const cookies = document.cookie.split(';');
  const _domain = isLocalHost() || !domain ? '' : `;domain=${domain}`;
  for (const element of cookies) {
    const cookie = element;
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT${_domain};path=${path}`;
  }
};

export const getUserNameLogin = () => {
  const accessToken =
    getCookie(TOKEN.ACCESS_TOKEN) || getCookie(TOKEN.SP_ACCESS_TOKEN);
  if (accessToken) {
    const tokenInfo = jwtDecode(accessToken);
    return tokenInfo.userId || tokenInfo.sub;
  }
  return '';
};

export const saveToken = (token, refreshToken) => {
  if (isEmpty(token)) return false;

  const tokenInfo = jwtDecode(token);
  const todayTime = new Date().getTime();
  const tokenExpirySeconds = tokenInfo.exp * 1000 - 60 * 1000 - todayTime;
  const refreshTokenExpirySeconds = 300000; // 5 minutes

  setCookie(SP_ACCESS_TOKEN, token, tokenExpirySeconds);
  setCookie(TOKEN.SP_ACCESS_TOKEN, token, tokenExpirySeconds);
  setCookie(SP_REFRESH_TOKEN, refreshToken, refreshTokenExpirySeconds);

  return true;
};

export const getUserRoles = () => {
  const accessToken = getCookie(TOKEN.ACCESS_TOKEN);
  if (accessToken) {
    const tokenInfo = jwtDecode(accessToken);
    return tokenInfo.roles;
  }
  return '';
};

export const clearAllCookies = () => {
  // Get all cookies
  const cookies = document.cookie.split(';');

  // Iterate through each cookie and delete it
  for (const cookie of cookies) {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;

    // Set the cookie's expiration date to a past date
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
  }
  console.log(cookies);
};
